import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
